import {ConnectionsItemChunk} from "../chunks/types/ConnectionsItemChunk";
import {connectionBodyChunkToConnection} from "./connectionBodyChunkToConnection";
import {Connection} from "./types/Connection";

export function connectionsItemChunkToConnection(
  connectionsItemChunk: ConnectionsItemChunk
): Connection<any, any, any> | null {
  const {
    captures: {
      1: connectionBodyChunk
    }
  } = connectionsItemChunk;
  return connectionBodyChunkToConnection(connectionBodyChunk);
}
